import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useHistory, useParams, useLocation } from "react-router-dom";
import useFetch from '../../useFetch';
import { Row, Col, Container } from 'react-bootstrap';
import parse from 'html-react-parser';
import { Helmet } from 'react-helmet';
import Banner from '../../components/banner.js';
import Sidebar from '../../components/sidebar.js';
import { logPageViews } from '../../Services/LoginService.js';
import { IconSearch,IconDental,IconUserExclamation, IconClipboardPlus, IconUserSquareRounded, IconInfoCircleFilled,IconListSearch, IconCaretDownFilled, IconInfoTriangleFilled,IconArrowBadgeUpFilled, IconZoomCheckFilled, IconFilterFilled, IconX, IconTrash, IconExternalLink, IconRestore, IconArrowRight } from '@tabler/icons-react'; // Import Icon
import { useMediaQuery, Select, InputLabel, NativeSelect, Skeleton, CircularProgress, Accordion, AccordionSummary, ButtonGroup, AccordionDetails, TextField, Link, Checkbox,Collapse, Divider, InputAdornment, ListItemButton, ListSubheader, Alert, AlertTitle, Chip, Typography, IconButton, FormControl, FormLabel, Button, Tooltip, FormControlLabel,FormGroup, Autocomplete, Tab, Tabs, Box,Table, TableBody, TableFooter, TableCell, TableContainer, TableHead, TableRow, Paper, TablePagination, Pagination, Badge, Fab, Zoom, List, ListItem, ListItemIcon, ListItemText, Stack, Dialog, DialogActions, DialogContent, DialogTitle  } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { cleanUp } from '../../Services/Utilities.js';
import '../../styles/DentalAntibioticGuide.scss'
import Illustration from '../../assets/ModuleIllustrations/DentalAntibioticGuide.svg';
import IllustrationNZ from '../../assets/ModuleIllustrations/NZ/DentalAntibioticGuide.svg';
import { useThemeManager } from '../../Context/ThemeManager.js';

const DentalAntibioticGuide = () => {
    const {theme} = useThemeManager();
    const [activeButton, setActiveButton] = useState('antibiotic');
    const { error, isPending, data } = useFetch('api/MimsDrug4dent/GetDentalAntibioticGuide')
    const [ scenario, setScenario ] = useState('')
    const isLgScreen = useMediaQuery('(min-width:1024px)');
    const country = localStorage.getItem("Activecountryversion");
    useEffect(() => {
        document.title = "Dental Antibiotic Use Guide"
        document.documentElement.style.setProperty('--primary-color', theme.primary);
        document.documentElement.style.setProperty('--bg', theme.bg);
        document.documentElement.style.setProperty('--titleGradient', theme.titleGradient);
    }, [])

    useEffect(() => {
        logPage(); 
        async function logPage() {
            await logPageViews('Antibiotic',scenario ?? "")
        }
    }, [scenario])

    if (isPending) {
        document.getElementById('loaderPage').style.display = 'flex'
    } else {
        document.getElementById('loaderPage').style.display = 'none'
    }
    const [isLoading, setIsLoading] = useState(true);
    const handleScenarioChange = (selectedScenario) => {
        setIsLoading(true); // Set your loader or any other side effects
        setScenario(selectedScenario);
      
        // Optionally delay to simulate loading (or wait for real async stuff)
        setTimeout(() => {
          setIsLoading(false);
        }, 500); // adjust or remove if real async loading is used
      };
    
    const muiTheme = useTheme();      
        const transitionDuration = {
            enter: muiTheme.transitions.duration.enteringScreen,
            exit: muiTheme.transitions.duration.leavingScreen,
        };
    const handleScrollUp = () => {
        window.scrollTo({
        top: 0,
        behavior: 'smooth'
        });
    };
    const sentinelRef = useRef(null);
    const [isFloating, setIsFloating] = useState(false);
    useEffect(() => {
        if (!isLgScreen) {
            setIsFloating(false);
            return;
        }
            
        const observer = new IntersectionObserver(
        ([entry]) => {
            setIsFloating(!entry.isIntersecting);
        },
        {
            root: null,
            threshold: 0,
        }
        );

        if (sentinelRef.current) {
        observer.observe(sentinelRef.current);
        }

        return () => {
        if (sentinelRef.current) {
            observer.unobserve(sentinelRef.current);
        }
        };
        
    }, [isLgScreen]);
      
    return (
        <>
           <Helmet>
                <meta name="viewport" content="width=device-width, initial-scale=1" />
            </Helmet>  
            <Banner />
            <Sidebar activeButton={activeButton} />
            <div id="DentalAntibioticGuide">
                <Container fluid id="main">
                    <div id="content">
                        <div id="contentCaption">
                            <h2>Dental Antibiotic Use Guide</h2>
                            {isLgScreen && (
                                <span>Comprehensive guide for appropriate dental antibiotic use and patient education.</span>
                            )}
                        </div>
                        {/* Sentinel for scroll up fab */}
                        <div ref={sentinelRef} style={{ height: '1px' }}></div>
                        <Row id="guides" style={{ padding: 0}}className={ isLgScreen ? 'my-3 d-flex flex-row' : 'my-4 d-flex flex-row'}>
                            <Col lg={4} md={12} style={{borderRight: isLgScreen ? "1px solid #e3e3e3": "none", padding: isLgScreen ? 32 : 0}}>
                                <div className='d-flex p-0' style={{color: theme.primary}}>
                                    <IconClipboardPlus style={{marginRight: 8}}/>
                                    <h5 style={{ fontWeight: "bold", marginBottom: "12px", }}>
                                        SCENARIO
                                    </h5>
                                </div>
                                
                                { isPending ? (
                                <Box
                                    sx={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    height: 360,
                                    }}
                                >
                                    <CircularProgress />
                                </Box>
                                ) : error ? (
                                <Typography color="error">Failed to load scenarios</Typography>
                                ) : (<>
                                {isLgScreen ? 
                                (
                                <Box sx={{ maxHeight: scenario ? "600px" : "360px", transition: 'max-height 0.2s ease', overflow: "auto" }}>
                                    <List>
                                    {data.map((val, index) => (
                                        <ListItemButton
                                        key={`${val.id}-${index}`}
                                        onClick={() => handleScenarioChange(val.scenario)}
                                        selected={scenario === val.scenario}
                                        sx={{
                                            my: 1,
                                            mr: 1,
                                            borderRadius: '16px',
                                            '&.Mui-selected': {
                                            bgcolor: theme.primary,
                                            color: 'white',
                                            fontWeight: 'bold',
                                            pointerEvents: scenario ? 'none' : 'auto', // Prevent clicking on selected item
                                            
                                            },
                                            '&.Mui-selected:hover': {
                                            bgcolor: theme.primary,
                                            },
                                            '&.Mui-selected .MuiListItemText-primary': {
                                            fontWeight: 'bold',
                                            },
                                        }}
                                        >
                                        <ListItemText primary={val.scenario} />
                                        </ListItemButton>
                                    ))}
                                    </List>
                                </Box>
                                ):(
                                    <FormControl fullWidth>
                                    <InputLabel
                                      htmlFor="scenario-native-select"
                                      sx={{
                                        pl: '34px', // shift the label to make space for the icon
                                        '&.MuiInputLabel-shrink': {
                                            pl: '0px', // Reset padding when label floats
                                          },
                                      }}
                                    >
                                      Select Scenario
                                    </InputLabel>
                                  
                                    <Box sx={{ position: "relative" }}>
                                      <IconClipboardPlus
                                        size={22}
                                        style={{
                                          position: "absolute",
                                          top: '50%',
                                          left: 9,
                                          transform: 'translateY(-50%)',
                                          pointerEvents: 'none',
                                          color: '#757575'
                                        }}
                                      />
                                  
                                      <Select
                                        native
                                        label="Select Scenario"
                                        value={scenario || ""}
                                        onChange={(e) => handleScenarioChange(e.target.value)}
                                        inputProps={{
                                          id: 'scenario-native-select',
                                          style: {
                                            paddingLeft: 42, // shifts the text value inside select
                                          },
                                        }}
                                      >
                                        <option value="" disabled></option>
                                        {data.map((val, index) => (
                                          <option key={`${val.id}-${index}`} value={val.scenario}>
                                            {val.scenario}
                                          </option>
                                        ))}
                                      </Select>
                                    </Box>
                                  </FormControl>
                                  
                                    
                                )
                                    }
                                </>)}


                            </Col>
                           
                            <Col style={{ boxShadow: isLgScreen ? "0 4px 16px rgba(43, 45, 65, 0.158)" : "none", padding: 0 }}>
                            {scenario ? (
                                <Box sx={{ position: 'relative' }}>
                                {isLoading && (
                                    <Box
                                    sx={{
                                        position: 'absolute',
                                        top: 0,
                                        left: 0,
                                        width: '100%',
                                        height: '100%',
                                        zIndex: 10,
                                        bgcolor: 'rgba(255,255,255,0.6)',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                    }}
                                    >
                                    <CircularProgress />
                                    </Box>
                                )}

                                <Row id="explanationContainer" className="d-flex flex-column m-0">
                                    <h3 style={{ fontWeight: 'bold', color: '#202020', lineHeight: 1.5 }}>{scenario}</h3>
                                    <hr className= {isLgScreen ? "my-3" :"my-1"} style={{ borderColor: '#727272' }} />

                                    <Col className= {isLgScreen ? "explanation my-3" : "explanation mt-3"} md={12}>
                                    <div className="title">
                                        <IconUserExclamation size={isLgScreen ? 24 : 20} style={{ marginRight: 8 }} />
                                        <h5 style={{ fontWeight: 'bold', fontSize: isLgScreen ? 20: 16 }}>Advice for patients</h5>
                                    </div>
                                    <div className="details">
                                        {isLoading ? (
                                        <>
                                            <Skeleton width="100%" height={20} />
                                            <Skeleton width="100%" height={20} />
                                            <Skeleton width="100%" height={20} />
                                        </>
                                        ) : (
                                        data
                                            .find((val) => val.scenario === scenario)
                                            ?.parientExplanation?.split('\\r\\n')
                                            .map((line, idx) => (
                                            <Typography key={idx} variant="body2" sx={{ lineHeight: 1.6 }}>
                                                {line}
                                            </Typography>
                                            ))
                                        )}
                                    </div>
                                    </Col>

                                    <Col className="explanation mt-3 d-flex flex-column" md={12}>
                                    <div className="title">
                                        <IconDental size={isLgScreen ? 24 : 20} style={{ marginRight: 8 }} />
                                        <h5 style={{ fontWeight: 'bold', fontSize: isLgScreen ? 20: 16 }}>Advice for dental practitioners</h5>
                                    </div>
                                    <div className="details">
                                        {isLoading ? (
                                        <>
                                            <Skeleton width="100%" height={20} />
                                            <Skeleton width="100%" height={20} />
                                            <Skeleton width="100%" height={20} />
                                        </>
                                        ) : (
                                        data
                                            .find((val) => val.scenario === scenario)
                                            ?.dentistExplanation?.split('\\r\\n')
                                            .map((line, idx) => (
                                            <Typography key={idx} variant="body2" sx={{ lineHeight: 1.6 }}>
                                                {line}
                                            </Typography>
                                            ))
                                        )}
                                    </div>
                                    </Col>
                                </Row>
                                </Box>
                            ) : (
                                <div
                                style={{
                                    textAlign: 'center',
                                    padding: isLgScreen ? '32px' : 0,
                                    height: '100%',
                                }}
                                >
                                <div id="illustration-container">
                                    <h6 style={{ lineHeight: 1.5 }}>
                                    SELECT A SCENARIO TO VIEW USAGE GUIDELINES.
                                    </h6>
                                    <img
                                    src={country === "New Zealand" ? IllustrationNZ : Illustration}
                                    alt="Illustration"
                                    id="illustration"
                                    style={{ maxWidth: '100%', height: 'auto' }}
                                    />
                                </div>
                                </div>
                            )}
                            </Col>

                        </Row>
                    </div>
                    <Zoom
                    in={isFloating && isLgScreen}
                    timeout={transitionDuration}
                    unmountOnExit
                    >
                        <Fab
                            color="primary"
                            aria-label="add"
                            sx={{
                            position: 'fixed',
                            bottom: 40,
                            right: 40,
                            zIndex: 100,
                            backgroundColor: theme.primary
                            }}
                            variant="extended"
                            onClick={handleScrollUp}
                            size="medium"
                        >
                                <IconArrowBadgeUpFilled sx={{ mr: 2 }} />
                                Scroll Up
                        </Fab>
                    </Zoom>
                </Container>
            </div>
        </>



    );
}

export default DentalAntibioticGuide;